<template>
    <div>
        <div class="title">
            <h3>Os campos com * são de preenchimento obrigatório</h3>
            <h5>Caso queira, você poderá salvar e continuar depois.</h5>
        </div>
        <div class="formulario">
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Declarações de Vínculo do Cliente'"
                        :TipoCliente="'Pessoa Jurídica'" :Sessao="'Declarações'" :SubSessao="'Vinculo cliente'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 60%">
                            <label class="label" for="nome">Você trabalha ou possui vínculo com a
                                {{ nomeEmpresa }}?*</label>
                            <div class="radio">
                                <input type="radio" id="true" value="true" name="VinculoRji" class="field__radio"
                                    @change="salvarAlteracoesLocalmente" v-model="localPJ.VinculoRji" />
                                <label for="sim" class="label__radio">
                                    Sim
                                </label>
                                <input type="radio" id="false" value="false" name="VinculoRji" class="field__radio"
                                    @change="salvarAlteracoesLocalmente" v-model="localPJ.VinculoRji" />
                                <label for="nao" class="label__radio">
                                    Não
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 80%">
                            <label class="label" for="nome">Você ou alguém de seu relacionamento exerce ou exerceu algum
                                cargo público nos últimos 5 anos?*</label>
                            <div class="radio">
                                <input type="radio" id="true" value="true" name="ConhecePoliticamenteExposta"
                                    class="field__radio" @change="salvarAlteracoesLocalmente"
                                    v-model="localPJ.ConhecePoliticamenteExposta" />
                                <label for="sim" class="label__radio">
                                    Sim
                                </label>
                                <input type="radio" id="false" value="false" name="ConhecePoliticamenteExposta"
                                    class="field__radio" @change="salvarAlteracoesLocalmente"
                                    v-model="localPJ.ConhecePoliticamenteExposta" />
                                <label for="nao" class="label__radio">
                                    Não
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 60%">
                            <label class="label" for="nome">Se sim, especifique</label>
                            <textarea @change="salvarAlteracoesLocalmente"
                                v-model="localPJ.ConhecePoliticamenteExpostaDescricao"
                                style="width: 100%; height: 80px; max-height: 120px;" class="field"></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Declaração de Propósitos'"
                        :TipoCliente="'Pessoa Jurídica'" :Sessao="'Declarações'" :SubSessao="'Proposito'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 60%">
                            <label class="label" for="nome">Em cumprimento ao disposto no artigo 2º, inciso III da
                                Circular nº 3.461/09, do Banco Central do Brasil,
                                o abaixo assinado declara os propósitos e a natureza da relação de negócios que pretende
                                manter com o(a) {{ nomeEmpresa }}.</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 100%">
                            <div class="checkbox-group">
                                <div class="checkbox">
                                    <input type="checkbox" id="cambio" value="Câmbio" name="Cambio"
                                        class="field__checkbox" @change="salvarAlteracoesLocalmente"
                                        v-model="localPJ.NegocioCambio" />
                                    <label for="cambio" class="label__checkbox">
                                        Câmbio
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <input type="checkbox" id="operacoes_credito" value="Operações de Crédito"
                                        name="OperacoesCredito" class="field__checkbox"
                                        @change="salvarAlteracoesLocalmente"
                                        v-model="localPJ.NegocioOperacoesCredito" />
                                    <label for="operacoes_credito" class="label__checkbox">
                                        Operações de Crédito
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <input type="checkbox" id="aplicacoes_investimentos"
                                        value="Aplicações/Investimentos" name="AplicacoesInvestimentos"
                                        class="field__checkbox" @change="salvarAlteracoesLocalmente"
                                        v-model="localPJ.NegocioAplicacoesInvestimentos" />
                                    <label for="aplicacoes_investimentos" class="label__checkbox">
                                        Aplicações/Investimentos
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <input type="checkbox" id="operacoes_acessorias"
                                        value="Operações Acessórias (prestação de serviços e/ou garantias)"
                                        name="OperacoesAcessorias" class="field__checkbox"
                                        @change="salvarAlteracoesLocalmente" v-model="localPJ.NegocioAcessorios" />
                                    <label for="operacoes_acessorias" class="label__checkbox">
                                        Operações Acessórias (prestação de serviços e/ou garantias)
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <input type="checkbox" id="intermediacao_operacoes"
                                        value="Intermediação de Operações (corretagem)" name="IntermediacaoOperacoes"
                                        class="field__checkbox" @change="salvarAlteracoesLocalmente"
                                        v-model="localPJ.NegocioIntermediacao" />
                                    <label for="intermediacao_operacoes" class="label__checkbox">
                                        Intermediação de Operações (corretagem)
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <input type="checkbox" id="outros" value="Outros" name="Outros"
                                        class="field__checkbox"
                                        @change="() => { salvarAlteracoesLocalmente(); verificarOutros(); }"
                                        v-model="localPJ.NegocioOutros" />
                                    <label for="outros" class="label__checkbox">
                                        Outros
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 60%">
                            <label class="label" for="nome">Especificar*</label>
                            <textarea @change="salvarAlteracoesLocalmente" v-model="localPJ.NegocioOutrosEspecificar"
                                style="width: 100%; height: 80px; max-height: 120px;" class="field"
                                :disabled="!localPJ.NegocioOutros"></textarea>
                            <p class="sub-label" for="nome">Caso os propósitos acima assinalados sejam alterados durante
                                a vigência de
                                nosso relacionamento com o(a) {{ nomeEmpresa }}, informarei imediatamente, de forma a
                                permitir a
                                necessária adequação dos controles exigidos pelas autoridades competentes.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'"
                        :NomeLabel="'FATCA (Foreign Account Tax Compliance Act) de Vínculo do Cliente'"
                        :TipoCliente="'Pessoa Jurídica'" :Sessao="'Declarações'" :SubSessao="'FACTA'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 60%">
                            <label class="label" for="nome">É Instituição Financeira Estrangeira (FFI) aderente ao
                                FATCA?*</label>
                            <div class="radio">
                                <input type="radio" id="true" value="true" name="Facta" class="field__radio"
                                    @change="salvarAlteracoesLocalmente" v-model="localPJ.Facta" />
                                <label for="sim" class="label__radio">
                                    Sim
                                </label>
                                <input type="radio" id="false" value="false" name="Facta" class="field__radio"
                                    @change="salvarAlteracoesLocalmente" v-model="localPJ.Facta" />
                                <label for="nao" class="label__radio">
                                    Não
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 50%">
                            <label class="label" for="nome">Se sim, informar o nº GIN:</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmente"
                                v-model="localPJ.NumeroGiin" id="emailSocio_1">
                        </div>
                        <div class="label__field" style="width: 50%">
                            <label class="label" for="nome">Caso não possua o nº GIN, informar os motivos:</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmente"
                                v-model="localPJ.NumeroGiinMotivos" id="emailSocio_1">
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 50%">
                            <label class="label" for="nome">Tem Sede ou Filial nos EUA?</label>
                            <div class="radio">
                                <input type="radio" id="true" value="true" name="SedeEua" class="field__radio"
                                    @change="salvarAlteracoesLocalmente" v-model="localPJ.SedeEua" />
                                <label for="sim" class="label__radio">
                                    Sim
                                </label>
                                <input type="radio" id="false" value="false" name="SedeEua" class="field__radio"
                                    @change="salvarAlteracoesLocalmente" v-model="localPJ.SedeEua" />
                                <label for="nao" class="label__radio">
                                    Não
                                </label>
                            </div>
                        </div>
                        <div class="label__field" style="width: 50%">
                            <label class="label" for="nome">É Sociedade Constituída sob a Legislação dos EUA?</label>
                            <div class="radio">
                                <input type="radio" id="true" value="true" name="SociedadeEua" class="field__radio"
                                    @change="salvarAlteracoesLocalmente" v-model="localPJ.SociedadeEua" />
                                <label for="sim" class="label__radio">
                                    Sim
                                </label>
                                <input type="radio" id="false" value="false" name="SociedadeEua" class="field__radio"
                                    @change="salvarAlteracoesLocalmente" v-model="localPJ.SociedadeEua" />
                                <label for="nao" class="label__radio">
                                    Não
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row">

                        <div class="label__field" style="width: 50%">
                            <label class="label" for="nome">Possui vínculo societário com alguma instituição
                                estrangeira?</label>
                            <div class="radio">
                                <input type="radio" id="true" value="true" name="SocietarioInstituicaoEstrangeira"
                                    class="field__radio" @change="salvarAlteracoesLocalmente"
                                    v-model="localPJ.SocietarioInstituicaoEstrangeira" />
                                <label for="sim" class="label__radio">
                                    Sim
                                </label>
                                <input type="radio" id="false" value="false" name="SocietarioInstituicaoEstrangeira"
                                    class="field__radio" @change="salvarAlteracoesLocalmente"
                                    v-model="localPJ.SocietarioInstituicaoEstrangeira" />
                                <label for="nao" class="label__radio">
                                    Não
                                </label>
                            </div>
                        </div>
                        <div class="label__field" style="width: 50%">
                            <label class="label" for="nome">Possui alguma fonte de renda em Mercado Estrangeiro?</label>
                            <div class="radio">
                                <input type="radio" id="true" value="true" name="FonteRendaMercadoEstrangeiro"
                                    class="field__radio" @change="salvarAlteracoesLocalmente"
                                    v-model="localPJ.FonteRendaMercadoEstrangeiro" />
                                <label for="sim" class="label__radio">
                                    Sim
                                </label>
                                <input type="radio" id="false" value="false" name="FonteRendaMercadoEstrangeiro"
                                    class="field__radio" @change="salvarAlteracoesLocalmente"
                                    v-model="localPJ.FonteRendaMercadoEstrangeiro" />
                                <label for="nao" class="label__radio">
                                    Não
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 50%">
                            <label class="label" for="nome">Se sim, quais país(es)?</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmente"
                                v-model="localPJ.SocietarioInstituicaoEstrangeiraEspecificacao"
                                id="SocietarioInstituicaoEstrangeiraEspecificacao">
                        </div>
                        <div class="label__field" style="width: 50%">
                            <label class="label" for="nome">Se sim, quais país(es)?</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmente"
                                v-model="localPJ.FonteRendaMercadoEstrangeiroEspecificacao"
                                id="FonteRendaMercadoEstrangeiroEspecificacao">
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 50%">
                            <label class="label" for="nome"> Possui conta corrente com movimentação no exterior?</label>
                            <div class="radio">
                                <input type="radio" id="true" value="true" name="ContaCorrenteExterior"
                                    class="field__radio" @change="salvarAlteracoesLocalmente"
                                    v-model="localPJ.ContaCorrenteExterior" />
                                <label for="sim" class="label__radio">
                                    Sim
                                </label>

                                <input type="radio" id="false" value="false" name="ContaCorrenteExterior"
                                    class="field__radio" @change="salvarAlteracoesLocalmente"
                                    v-model="localPJ.ContaCorrenteExterior" />
                                <label for="nao" class="label__radio">
                                    Não
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 50%">
                            <label class="label" for="nome">Se sim, quais país(es)?</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmente"
                                v-model="localPJ.ContaCorrenteExteriorEspecificacao"
                                id="ContaCorrenteExteriorEspecificacao">
                        </div>
                    </div>
                </div>
            </div>
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Declarações'"
                        :TipoCliente="'Pessoa Jurídica'" :Sessao="'Declarações'" :SubSessao="'Declarações'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 60%">
                            <label class="label" for="nome">Declaro que opero por conta:*</label>
                            <div class="radio">
                                <input type="radio" id="true" value="true" name="OperaPorConta" class="field__radio"
                                    @change="salvarAlteracoesLocalmente" v-model="localPJ.OperaPorConta" />
                                <label for="sim" class="label__radio">
                                    Própria
                                </label>
                                <input type="radio" id="false" value="false" name="OperaPorConta" class="field__radio"
                                    @change="salvarAlteracoesLocalmente" v-model="localPJ.OperaPorConta" />
                                <label for="nao" class="label__radio">
                                    de Terceiros
                                </label>
                            </div>
                        </div>
                    </div>
                    <DeclaracoesDocumentos />
                </div>
            </div>
        </div>
        <div class="footerFormulario">
            <div class="buttonsAcoes">
                <button class="btnDefault" @click="salvarInformacoes" v-if="this.Edicao != true">Salvar e continuar
                    depois</button>
                <button class="btnDefault" @click="salvarInformacoes" v-if="this.Edicao == true">Salvar</button>
                <button class="btnBlue" v-if="!Edicao" @click="proximaEtapa">Avançar</button>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import DeclaracoesDocumentos from './DeclaracoesDocumentos.vue';
import LabelDisclaimer from '../Utilitarios/Disclaimer/LabelDisclaimer.vue'

export default {
    name: 'CadastroPF_Declaracoes',
    props: ['informacoesDeclaracoes', 'Edicao'],
    components: { LabelDisclaimer, DeclaracoesDocumentos },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            listaDocumentos: 'GET_LISTA_DOCUMENTOS',
            listaDocumentosCliente: 'GET_LISTA_DOCUMENTOS_CLIENTE',
            getConfiguracoes: 'GET_CONFIGURACOES',
        }),
    },
    data() {
        return {
            permitirAvancar: false,
            localPJ: this.informacoesDeclaracoes,
            nomeEmpresa: '',
            obrigatorioPerguntaDeclaracao: false
        }
    },
    watch: {
        infoDeclaracoes() {
            this.localPJ = this.infoDeclaracoes;
        },
        listaDocumentosCliente() {
            this.validarFormulario();
        }
    },
    async mounted() {
        this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
        await this.fetchConfiguracao(['OBRIGATORIEDADE - PERGUNTA: DECLARACAO DE PROPOSITO']);
        var chave = this.getConfiguracoes('OBRIGATORIEDADE - PERGUNTA: DECLARACAO DE PROPOSITO');
        console.log('chave', chave)
        if(chave){
            this.obrigatorioPerguntaDeclaracao = chave.Valor == 'S' ? true : false;
        }

        this.validarFormulario();
    },
    methods: {
        ...mapActions({
            fetchConfiguracao: 'FETCH_CONFIGURACOES'
        }),
        proximaEtapa() {
            this.validarFormulario(true);
            if (this.permitirAvancar) {
                this.$store.commit('SET_ETAPA_CADASTRO', 8);
            }
        },
        validarFormulario(submeter) {
            this.permitirAvancar = true;
            var nomeDoCampo = '';
            if (this.listaDocumentos != null) {
                if (this.listaDocumentosCliente == null) {
                    this.permitirAvancar = false;
                }

                this.listaDocumentos.forEach(documentoObj => {
                    if (documentoObj.TipoCliente == 'Pessoa Jurídica' && documentoObj.Obrigatoriedade == 'Sim') {
                        if (!this.listaDocumentosCliente.some(p => p != null && documentoObj != null && p.TemplateId === documentoObj.TemplateId) ||
                        this.listaDocumentosCliente.some(p => p != null && documentoObj != null && p.TemplateId === documentoObj.TemplateId &&  p.StatusAssinatura == 'Pendente')) {
                            this.permitirAvancar = false;
                            nomeDoCampo = documentoObj.NomeDocumento;
                        }
                    }
                });
            }
            if (submeter && nomeDoCampo != '') {
                this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O documento ` + nomeDoCampo + ` é obrigatório e não foi assinado, aceito os termos para avançar`,
                });
                this.permitirAvancar = false;
            }

            if(submeter && this.obrigatorioPerguntaDeclaracao && !this.localPJ.NegocioOutros){
                   this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O campo 'Declaração de Propósitos' é obrigatório e não foi informado.`,
                });
                this.permitirAvancar = false;
            }

            if (submeter && this.localPJ.NegocioOutros && this.localPJ.NegocioOutrosEspecificar == '') {
              this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O campo 'Especificar' é obrigatório e não foi informado.`,
                });
                this.permitirAvancar = false;
            }

            return true;

        },
        salvarInformacoes() {
            this.$store.commit('SET_PJ_SALVAR_INFO', true);
        },
        salvarAlteracoesLocalmente() {
            this.$store.commit('SET_PJ_SALVAR_INFO_DECLARACOES', this.localPJ);
        },
        verificarOutros() {
            if (!this.localPJ.NegocioOutros) {
                // Limpar o valor do campo de texto quando o checkbox for desmarcado
                this.localPJ.NegocioOutrosEspecificar = '';
            }
        }
    }
}

</script>